import Api from './xo_service';

export default {
    createIssue(body) {
        return Api().post('/issues',body)
    },
    reportIssue(body) {
        return Api().post('/issues/report',body)
    },
    getIssue(id) {
        return Api().get(`/issues/${id}`)
    }
}